import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import page5_section1 from "../../../assets/images/AboutVedaz/page5_section1.jpg";
import page5_section2 from "../../../assets/images/AboutVedaz/page5_section2.jpg";
import classes from "../AboutVedaz.styles";

interface Props {
  chapterIndex: number;
  onDimensionClick: (tabIndex: number) => void;
}

const AnalysisOverview = ({ chapterIndex, onDimensionClick }: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      {/* Section 1: Background image with glass content card */}
      <Box sx={classes.bgSection}>
        <Box component="img" src={page5_section1} alt="" sx={classes.bgSectionMedia} />
        <Box sx={classes.bgSectionOverlay} />
        <Box sx={classes.bgSectionContent}>
          <Typography
            sx={{
              ...classes.sectionHeading,
              background:
                "linear-gradient(128deg, #FFFFFF 0%, #EDE9FE 28%, #A78BFA 52%, #6366F1 72%, #22D3EE 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {t("about_analysis_heading")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "380px" }}>
            {t("about_analysis_s1_body1")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "380px", mb: 0 }}>
            {t("about_analysis_s1_body2")}
          </Typography>
        </Box>
      </Box>

      {/* Section 2: Side-by-side — text left, image right */}
      <Box sx={classes.sideRow}>
        <Box sx={classes.sideContent}>
          <Typography
            sx={{
              ...classes.sectionHeading,
              background:
                "linear-gradient(135deg, #FFFFFF 10%, #C4B5FD 55%, #9053F6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {t("about_analysis_heading")}
          </Typography>
          <Typography sx={classes.sectionSubheading}>
            {t("about_analysis_s2_subheading")}
          </Typography>
          <Typography sx={classes.bodyText}>{t("about_analysis_s2_body1")}</Typography>
          <Typography sx={classes.bodyText}>{t("about_analysis_s2_body2")}</Typography>
          <Typography sx={classes.bodyText}>{t("about_analysis_s2_body3")}</Typography>
          <Typography sx={{ ...classes.bodyText, mb: 0 }}>
            {t("about_analysis_s2_body4")}
          </Typography>
        </Box>
        <Box sx={classes.sideImage}>
          <img src={page5_section2} alt={t("about_analysis_s2_subheading")} />
        </Box>
      </Box>
    </Box>
  );
};

export default AnalysisOverview;
